<div [ngClass]="{'blocked': userData && userData.Status && userData.Status === '4'}"
     [ngStyle]="{'visibility': notHideNavOnLoad ? 'visible' : 'hidden'}" [class.toggleContent]="!toggleContent"
     class="awesomeNavigation d-flex align-items-center py-3 {{routerForNavbar}} {{language}}"
     *ngIf="!lotteryService.isTablet && !lotteryService.isMobile">
  <div class="align-items-center container d-flex justify-content-between navMenuWrapper position-relative py-3">
    <div class="suspInfo"
         *ngIf="userData && userData.Status && userData.Status === '4'">{{'nav.suspInfo1' | translate }}
      <span (click)="userService.checkStatus(userData.Status)">{{'nav.suspInfo2' | translate }}</span></div>
    <div class="leftSide d-flex align-items-center" #leftSide>
      <div class="logo"><a routerLink="/" (click)="hideRegModal();"></a></div>
      <div class="nav-element nav-lotteries ps-2">
        <a [ngClass]="{'active': activeRouteParameters('/lotteries', '/lotteries-results')}"
           [routerLink]="[language ? language : 'en', 'lotteries']">

          <span class="ico ico-lotteries ico-lotteries-{{language}}">
            <img src="../../../assets/images/navigation/icons/Lotto/FullColor.png" class="h20px"/>
          </span>
          <span class="text font-proximanova fz-14px">{{ 'awesomeNav.lotteries' | translate }}</span>
        </a>
      </div>
      <div class="nav-element ps-2">
        <a [ngClass]="{'active': activeRouteParameters('/lotteries-results', '/lotteries-results')}"
           [routerLink]="[language ? language : 'en', 'lotteries-results']">
          <span class="ico ico-lotteries ico-lotteries-{{language}}">
            <img src="../../../assets/images/navigation/icons/results/outline.png" class="h20px"/>
          </span>
          <span class="text font-proximanova fz-14px">{{ 'awesomeNav.lottoResults' | translate }}</span>
        </a>
      </div>
      <div class="nav-element nav-casino ms-2">
        <a [ngClass]="{'active': activeRouteParameters('/casino', '/casino')}"
           [routerLink]="[language ? language : 'en', 'casino']">
          <span class="ico ico-lotteries ico-lotteries-{{language}}">
            <img src="../../../assets/images/navigation/icons/Casino/FullColor.svg" width="20px" height="20px"/></span>
          <span class="text">{{ 'awesomeNav.casino' | translate }}</span>
        </a>
      </div>
      <div class="nav-element nav-sports ms-2">
        <a [ngClass]="{'active': activeRouteParameters('/sports-bet', '/sports-bet')}"
           [routerLink]="[language ? language : 'en', 'sports-bet']">
          <span class="ico ico-lotteries ico-lotteries-{{language}}">
            <img src="../../../assets/images/navigation/icons/sports-bet/sports-icon.png" width="20px" height="20px"/></span>
          <span class="text">{{ 'awesomeNav.sports-bet' | translate }}</span>
        </a>
      </div>
      <div class="nav-element ps-2">
        <a *ngIf="!loggedIn" (click)="goToLogin(loginForm);"
           [ngClass]="{'active': activeRouteParameters('/dashboard', '/bonuses')}"
           [routerLink]="[language ? language : 'en', 'my-entries']"
        >
          <span class="ico ico-lotteries ico-lotteries-{{language}}">
            <img src="../../../assets/images/navigation/icons/my-account/outline.png" class="h20px"/></span>
          <span class="text font-proximanova fz-14px">{{ 'awesomeNav.myAccount' | translate }}</span>
        </a>
        <a *ngIf="loggedIn" (click)="goToDashboard('my-entries');"
          [ngClass]="{'active': activeRouteParameters('/dashboard', '/bonuses')}"
           [routerLink]="[language ? language : 'en', 'my-entries']"
        >
          <span class="ico ico-lotteries ico-lotteries-{{language}}">
            <img src="../../../assets/images/navigation/icons/my-account/outline.png" class="h20px"/></span>
          <span class="text font-proximanova fz-14px">{{ 'awesomeNav.myAccount' | translate }}</span>
        </a>
      </div>
      <div class="nav-element ps-2">
        <a [ngClass]="{'active': activeRouteParameters('/contact-us', '/contact-us')}"
           [routerLink]="[language ? language : 'en', 'contact-us']">
          <span class="ico ico-lotteries ico-lotteries-{{language}}">
            <img src="../../../assets/images/navigation/icons/support/outline.png" class="h20px"/></span>
          <span class="text font-proximanova fz-14px">{{ 'awesomeNav.support' | translate }}</span>
        </a>
      </div>
      <div class="nav-element nav-more ps-2">
        <div class="nav-more-wrapper">
          <span class="text font-proximanova fz-14px">{{ 'awesomeNav.more' | translate }}
            <img class="moreIcon" src="../../../assets/images/navigation/icons/down-arrow.svg"/>
          </span>
          <div class="tooltipBoxWrapper tooltipMoreWrapper">
            <div class="tooltipBox tooltipMore">
              <ul>
                <li><a
                  [routerLink]="[language ? language : 'en', 'packages']">{{ 'awesomeNav.packages' | translate }}</a>
                </li>
                <li><a [routerLink]="[language ? language : 'en', 'faq']">{{ 'awesomeNav.faq' | translate }}</a></li>
              </ul>
              <div class="brandNewLanguageSwitcher" *ngIf="languageSwitcherReadyToShow">
                <app-dw-select
                  [options]="sortValues"
                  [selected]="selected_method_show_name"
                  [image]="true"
                  (change)="switchLanguage($event)"
                  (display)="displayChanger($event)"
                  [displayer]="'brandNewLanguageSwitcher'">
                </app-dw-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="rightSide d-flex align-items-center" #rightSide>
      <app-free-spin-button *ngIf="userData && userData.HasFreeSpins"></app-free-spin-button>
      <div class="nav-element no-border login">
        <span *ngIf="!loggedIn" (click)="goToLogin(loginForm);" class="text font-proximanova fz-14px">{{ 'awesomeNav.login' | translate }}</span>
        <span *ngIf="loggedIn" class="loggedin">
          <div *ngIf="userDataNameWithGender?.Gender == 'Mr.'" class="gender-man"></div>
          <div *ngIf="userDataNameWithGender?.Gender == 'Ms.' || userDataNameWithGender?.Gender == 'Mrs.'"
               class="gender-woman"></div>
          <div class="user-dashboard-name">
            <span class="nameWithHi">
              <span class="light"
                    *ngIf="userDataNameWithGender?.FirstName.length <= 10">{{ 'awesomeNav.hi' | translate }}<span
                class="addChar">,</span></span>
              <span class="firstName"> {{userDataNameWithGender?.FirstName}}</span>
              <span class="lastName"><!-- {{userDataNameWithGender?.LastName}}--></span>
              <img class="moreIcon" src="../../../assets/images/navigation/icons/down-arrow.svg"/></span>
          </div>
          <div class="tooltipBoxWrapper userMenuTooltip">
            <div class="tooltipBox userMenuTooltipBody">
              <ul>
                <li class="menu-icon ico-entries"
                    (click)="goToDashboard('my-entries');">{{ 'awesomeNav.myEntries' | translate }}</li>
                <li class="menu-icon ico-bonuses"
                    (click)="goToDashboard('bonuses');">{{ 'awesomeNav.bonuses' | translate }}</li>
                <li class="menu-icon ico-deposit"
                    (click)="triggerDeposit();">{{ 'awesomeNav.deposit' | translate }}</li>
                <li class="menu-icon ico-logout" (click)="logOut($event)">{{ 'awesomeNav.logOut' | translate }}</li>
              </ul>

            </div>
          </div>
        </span>
      </div>
      <div class="nav-element signup">
        <button *ngIf="!loggedIn" class="przycisk green medium signupButton"
                (click)="goToRegistration(); step = 1; modalSize = 'modal-md'">{{ 'awesomeNav.signup' | translate }}</button>
        <div *ngIf="loggedIn" class="depositBox" (click)="triggerDeposit();">
          <div *ngIf="currency && currency.Code"
            class="depositValue">{{ userBalance | currency: currency.Code:currency.Symbol:afterComma:(subscriptionsService.countryCodeValue || 'en') }}</div>
          <div class="depositText">{{ 'awesomeNav.deposit' | translate }}</div>
          <div class="depositPlus">+</div>
        </div>
      </div>
      <div class="nav-element cart">
        <a [routerLink]="[language ? language : 'en', 'cart']">
          <button class="przycisk orange medium cartButton">
            <img src="../../../assets/images/navigation/icons/ic-cart-winaija.svg" class="t4px ps-3"/>
            <span class="text pe-2">{{ 'awesomeNav.cart' | translate }}</span>
            <span *ngIf="cartItems" [ngClass]="{'twodigits' : cartItems >= 10}" class="cart_items">
              <span *ngIf="cartItems >=100">99+</span>
              <span *ngIf="cartItems <= 99">{{cartItems}}</span>
            </span>
          </button>
        </a>
      </div>
    </div>
    <div class="brandNewLanguageSwitcher top" *ngIf="languageSwitcherReadyToShow">
      <app-dw-select
        [options]="sortValues"
        [selected]="selected_method_show_name"
        [image]="true"
        (change)="switchLanguage($event)"
        (display)="displayChanger($event)"
        [displayer]="'brandNewLanguageSwitcher'">
      </app-dw-select>
    </div>
    <div class="bottomLine"></div>
  </div>
</div>
<app-free-spin-button
  *ngIf="(lotteryService.isTablet || lotteryService.isMobile) && (userData && userData.HasFreeSpins)"></app-free-spin-button>
<div *ngIf="lotteryService.isTablet || lotteryService.isMobile" class="awesomeNavigationMobile {{routerForNavbar}}"
     [ngClass]="{'blocked': userData && userData.Status && userData.Status === '4'}">
  <div class="suspInfo"
       *ngIf="userData && userData.Status && userData.Status === '4'">{{'nav.suspInfo1' | translate }}
    <br><span (click)="userService.checkStatus(userData.Status)">{{'nav.suspInfo2' | translate }}</span></div>
  <div class="leftSide d-flex align-items-center">
    <button *ngIf="!loggedIn" class="przycisk orange small signupButton"
            (click)="goToRegistration(); step = 1; modalSize = 'modal-md'">{{ 'awesomeNav.signup' | translate }}</button>
    <span *ngIf="loggedIn" class="loggedin">
      <div *ngIf="userDataNameWithGender?.Gender == 'Mr.'" class="gender-man"></div>
      <div *ngIf="userDataNameWithGender?.Gender == 'Ms.' || userDataNameWithGender?.Gender == 'Mrs.'"
           class="gender-woman"></div>
      <div (click)="goToDashboard('');" class="user-dashboard-name"
           [ngClass]="{'overflowed' : userDataNameWithGender?.FirstName.length >= 10 }">
        <span class="nameWithHi"><span class="light"
                                       *ngIf="userDataNameWithGender?.FirstName.length <= 6">{{ 'awesomeNav.hi' | translate }}
          , </span>{{userDataNameWithGender?.FirstName}}</span>
      </div>
    </span>
  </div>
  <a routerLink="/" (click)="hideRegModal();" class="centerLogo"></a>
  <div class="rightSide" [ngClass]="{'noItemsInCart' : cartItems < 1}">
    <button *ngIf="!loggedIn" (click)="goToLogin(loginForm);"
            class="przycisk green small text loginMobile">{{ 'awesomeNav.login' | translate }}</button>
    <button class="cartMobile" [ngClass]="{'loggedin': loggedIn}" [routerLink]="[language ? language : 'en', 'cart']">
      <span class="text">{{ 'awesomeNav.cart' | translate }}</span>
      <img src="../../../assets/images/navigation/icons/ic-cart.svg"/>
      <img *ngIf="brand === 'winaija'" src="../../../assets/images/navigation/icons/ic-cart-winaija.svg"/>
      <span *ngIf="cartItems" [ngClass]="{'twodigits' : cartItems >= 10}" class="cart_items">
        <span *ngIf="cartItems >=100">99+</span>
        <span *ngIf="cartItems <= 99">{{cartItems}}</span>
      </span>
    </button>
    <div *ngIf="loggedIn" class="depositBoxMobile" (click)="triggerDeposit();">
      <div *ngIf="currency && currency.Code"
           class="depositValue">{{ userBalance | currency: currency.Code:currency.Symbol:afterComma:(subscriptionsService.countryCodeValue || 'en') }}</div>
      <div class="depositPlus">+</div>
    </div>
  </div>
</div>
<div *ngIf="lotteryService.isTablet || lotteryService.isMobile"
     class="awesomeNavigationMobileBottom {{routerForNavbar}}">
  <div class="awesomeNavigationMobileBottomLineWrapper {{routerForNavbar}}">
    <div class="movingElement {{routerForNavbar}}"></div>
  </div>
  <div class="bottomNavElement bottom-lotteries"
       [ngClass]="{'active': activeRouteParameters('/lotteries', '/lotteries')}"
       [routerLink]="[language ? language : 'en', 'lotteries']">
    <div class="bottomIco"></div>
    <span class="text font-proximanova">{{ 'awesomeNav.lotteries' | translate }}</span></div>
<!--  <div class="bottomNavElement bottom-scratch"-->
<!--       [ngClass]="{'active': activeRouteParameters('/scratchcards', '/scratchcards')}"-->
<!--       [routerLink]="[language ? language : 'en', 'scratchcards']">-->
<!--    <div class="bottomIco"></div>-->
<!--    <span class="text">{{ 'awesomeNav.scratch' | translate }}</span>-->
<!--  </div>-->
  <div class="bottomNavElement bottom-lottery-results"
       [ngClass]="{'active': activeRouteParameters('/lotteries-results', '/lotteries-results')}"
       [routerLink]="[language ? language : 'en', 'lotteries-results']">
    <div class="bottomIco"></div>
    <span class="text">{{ 'awesomeNav.lottoResults' | translate }}</span>
  </div>
<!--  <div class="bottomNavElement bottom-games" [ngClass]="{'active': activeRouteParameters('/games', '/games')}"-->
<!--       [routerLink]="[language ? language : 'en', 'games']">-->
<!--    <div class="bottomIco"></div>-->
<!--    <span class="text">{{ 'awesomeNav.games' | translate }}</span>-->
<!--  </div>-->
  <div class="bottomNavElement bottom-casino" [ngClass]="{'active': activeRouteParameters('/casino', '/casino')}"
       [routerLink]="[language ? language : 'en', 'casino']">
    <div class="bottomIco"></div>
    <span class="text">{{ 'awesomeNav.casino' | translate }}</span>
  </div>
  <div class="bottomNavElement bottom-support" [ngClass]="{'active': activeRouteParameters('/support', '/support')}"
       [routerLink]="[language ? language : 'en', 'support']">
    <div class="bottomIco"></div>
    <span class="text">{{ 'awesomeNav.support' | translate }}</span>
  </div>
  <div class="bottomNavElement bottom-more">
    <app-lotteries-navigation></app-lotteries-navigation>
  </div>
</div>

<app-dialog [(visible)]="ifGameError" class="errorOnScratchWrapp">
  <div class="errorOnScratch">
    <img src="../../../assets/images/faq/ic-404.png" alt="404">
    <h4 *ngIf="error000">{{'scratchcards.error000' | translate}}</h4>
    <h4 *ngIf="error102">{{'scratchcards.error102' | translate}}</h4>
    <h4 *ngIf="error69">{{'errors.069' | translate }}</h4>
    <div class="text-center">
      <a href="#" (click)="closeScratchError($event); " class="btn">OK</a>
    </div>
  </div>
</app-dialog>
<app-jinni-modal [(visible)]="showRegister">
  <app-fresh-registration (loggedIn)="setLogin($event)"></app-fresh-registration>
</app-jinni-modal>
<app-jinni-modal [(visible)]="showLogin">
  <app-login></app-login>
</app-jinni-modal>
<app-jinni-modal [(visible)]="showOtpVerify">
  <app-otp-verify [otpAction]="otpAction"></app-otp-verify>
</app-jinni-modal>
<app-jinni-modal [(visible)]="customErrorMessageOnModalVisible">
  <app-jinni-error-modal></app-jinni-error-modal>
</app-jinni-modal>
<app-dialog [(visible)]="showForgetPassword" [(modalSize)]="modalSize" [class.forgot-modal-mobile]="!toggleContent"
            class="forgot-modal">
  <div class="popup-content forgot-popup fp-1">
    <a href="#" class="close"></a>
    <a [ngClass]="{'active' : step != 3}" class="registerORlogin"
       (click)="showLogin = true; showForgetPassword = false; modalSize = 'modal-sm modal-sm-wider'">{{ 'modals.login' | translate
      }}
    </a>
    <img src="../../../assets/images/modals/forget/ic_key.svg" alt="">
    <h3>{{ 'forgotpass.fp1' | translate }}</h3>
    <p>{{ 'forgotpass.fp2' | translate }}</p>
    <form #forgotForm="ngForm" (ngSubmit)="resetPasswordForm(forgotForm.value)">
      <input (keydown.space)="$event.preventDefault()" class="input-mail" type="email" placeholder="Email"
             maxlength="{{maxLengthEmail}}"
             [(ngModel)]="email" name="email">
      <div *ngIf="errorVar === '034'"
           class="notValid checkbox-error active regular">{{ 'ferrors.15' | translate }}</div>
      <div *ngIf="errorVar === '037'"
           class="notValid checkbox-error active regular">{{ 'ferrors.16' | translate }}</div>
      <div *ngIf="successMessage" class="valid active regular">{{ 'success.18' | translate }}</div>
      <button type="submit" [ngClass]="{'disabled-btn' : isLoadingButton }" class="btn btn-green">
        {{ 'forgotpass.fpbtn' | translate }}
        <span *ngIf="isLoadingButton" class="spinner"></span>
      </button>
    </form>
  </div>
</app-dialog>
<app-dialog [(visible)]="resetPassword" [(modalSize)]="modalSize" class="forgot-modal">
  <div class="popup-content forgot-popup reset-form">
    <a href="#" class="close"></a>
    <div (click)="
                showLogin = true;
                resetPassword = !resetPassword;
                modalSize = 'modal-md';
                error73 = false;
                error12 = false;" class="registerORlogin">{{ 'modals.login' | translate }}
    </div>
    <img src="../../../assets/images/modals/forget/ic_key.svg" alt="">
    <h3 class="mobile-hide">{{ 'resetpass.rs1' | translate }}</h3>
    <h3 class="mobile-show">{{ 'resetpass.rs1m' | translate }}</h3>
    <p>{{ 'resetpass.rs2' | translate }}</p>
    <form #setNewPasswordForm="ngForm" (ngSubmit)="setNewPassword(setNewPasswordForm.value)">
      <input (keydown.space)="$event.preventDefault()" [(ngModel)]="resetToken" name="resetToken"
             class="input-password"
             type="password" hidden>
      <input (keydown.space)="$event.preventDefault()" [(ngModel)]="resetEmail" name="email" class="input-password"
             maxlength="{{maxLengthEmail}}" type="password" hidden>
      <input (keydown.space)="$event.preventDefault()" ngModel name="password" class="input-password" type="password"
             placeholder="{{ 'resetpass.rs3' | translate }}" #password="ngModel">
      <input (keydown.space)="$event.preventDefault()" ngModel name="repeat_password" class="input-password"
             type="password" placeholder="{{ 'resetpass.rs4' | translate }}" #repeat_password="ngModel">
      <div *ngIf="error1010" class="notValid checkbox-error active regular">{{ 'errors.1010' | translate }}</div>
      <div *ngIf="error48" class="notValid checkbox-error active regular">{{ 'errors.048' | translate }}</div>
      <div *ngIf="errorDefault"
           class="notValid checkbox-error active regular">{{ 'errors.Default' | translate }}</div>
      <button type="submit" class="btn btn-green"
              [disabled]="setNewPasswordForm.value.password !== setNewPasswordForm.value.repeat_password || !setNewPasswordForm.value.password || (setNewPasswordForm.value.password && setNewPasswordForm.value.password.length === 0)">{{ 'static.submit' | translate }}</button>
    </form>
  </div>
</app-dialog>
<app-dialog [(visible)]="resetSuccess && loggedIn" [(modalSize)]="modalSize" class="forgot-modal">
  <div class="popup-content forgot-popup reset-success">
    <a href="#" class="close"></a>
    <a class="registerORlogin"
       (click)=" showLogin = !showLogin; resetSuccess = !resetSuccess; modalSize = 'modal-md'">
      {{ 'modals.login' | translate }}
    </a>
    <img src="../../../assets/images/modals/forget/ic_key2.png" alt="">
    <h3><span class="mobile-show">{{ 'success.s12a' | translate }}</span><span
      class="mobile-hide">{{ 'success.s12a' | translate }}</span></h3>
    <p><span class="mobile-show">{{ 'success.s12b' | translate }}</span><span
      class="mobile-hide">{{ 'success.s12b' | translate }}</span></p>
    <div class="">
      <a href="#" (click)="$event.preventDefault; resetSuccess = !resetSuccess; closeModalSuccess();"
         class="btn">{{ 'static.done' | translate }}</a>
    </div>
  </div>
</app-dialog>
<app-dialog [(visible)]="resetLinkSend" [(modalSize)]="modalSize" class="forgot-modal">
  <div class="popup-content forgot-popup">
    <a href="#" class="close"></a>
    <div (click)="
            showLogin = !showLogin;
            resetLinkSend = !resetLinkSend;
            modalSize = 'modal-md'" class="registerORlogin">{{ 'modals.login' | translate }}
    </div>
    <img src="../../../assets/images/modals/send/ic_send.svg" alt="">
    <h3>{{ 'success.s11a' | translate }}</h3>
    <p>{{ 'success.s12b' | translate }}</p>
    <div class="">
      <a href="#" class="btn">{{ 'static.check' | translate }}</a>
    </div>
  </div>
</app-dialog>
<app-dialog [(visible)]="showRecall" [(modalSize)]="modalSize" class="password-link-send-modal">
  <div class="popup-content forgot-popup reset-success">
    <a [ngClass]="{'active' : step != 3}" class="registerORlogin"
       (click)="showLogin = true; showForgetPassword = false; resetPassword = false; showRecall = false; modalSize = 'modal-sm modal-sm-wider'">{{ 'modals.login' | translate }}
    </a>
    <img src="../../../assets/images/icons/reset-pass.png"/>
    <h3>{{ 'success.s11a' | translate }}</h3>
    <p>{{ 'resetpass.rs5' | translate }} <span *ngIf="lotteryService.isMobile"><br></span> <span
      class="bold">{{ toSendEmail }}</span></p>
    <p class="reset-success-p" *ngIf="!lotteryService.isMobile">{{ 'resetpass.rs6' | translate }}</p>
    <p class="reset-success-p" *ngIf="lotteryService.isMobile">{{ 'resetpass.rs6Mobile1' | translate }}
      <br> {{ 'resetpass.rs6Mobile2' | translate }}</p>
    <div class="">
      <a href="#"
         (click)="$event.preventDefault; showLogin = false; showForgetPassword = false; resetPassword = false; showRecall = false; toggleContentV(true); closeResetModal()"
         class="btn">{{ 'resetpass.rs8' | translate }}</a>
    </div>
  </div>
</app-dialog>
<app-dialog #restrictBanner [(visible)]="showRestricted || showRestrictedLoginRegister" [(preventClosing)]="prevent"
            [(modalSize)]="modalSize" class="restrictedarea-modal">
  <div class="inner">
    <img src="../../../assets/images/modals/restricted/ic_restricted.svg"/>
    <h4>{{ 'ferrors.12' | translate }}</h4>
  </div>
</app-dialog>

<app-scratch-checkout [tickets]="checkoutTickets" [id]="checkoutId" [myScratch]="myScratch"
                      [runModal]="scrCheckCnt"></app-scratch-checkout>
<app-dialog [style.width.px]="frameWidth" [style.height.px]="frameHeight" [(visible)]="showGameModal"
            [preventClosing]="true" [closeOnlyByButton]="true" #gameModal modal-size="modal-md" class="game-modal">
  <span class="loader"></span><span class="loading">{{ 'carousel.loading' | translate }}</span>
  <iframe id="game-iframe" width="{{frameWidth}}" height="{{frameHeight}}" #iframe [src]="gameURL | safe"
          class="{{showIframe}}"></iframe>
</app-dialog>
<div *ngIf="confettiGo === 'go'" class="winnerConfetti {{confettiGo}}">
  <span class="confetti" *ngFor="let item of createRange(100);"></span>
</div>

<app-jinni-tooltip></app-jinni-tooltip>
<app-server-message *ngIf="serverBannerMessage"></app-server-message>
<app-paystack></app-paystack>
